import { useMemo, useState } from "react";
import * as XLSX from "xlsx";
import InputForm from "../../../componentes/input/input";
import Button from "../../../componentes/button/button";

export function TabelaVeiculos({ veiculos }) {
    const [filtro, setFiltro] = useState("");

    const veiculosFiltrados = useMemo(() => {
        if (!filtro) return veiculos || [];

        const termo = filtro.toLowerCase();

        return veiculos.filter(v =>
            Object.values(v).some(value =>
                value !== null &&
                value !== undefined &&
                value.toString().toLowerCase().includes(termo)
            )
        );
    }, [filtro, veiculos]);

    return (
        <div className="surface-card py-2 px-4">
            <h2 className="text-lg font-display font-semibold mb-3 text-foreground">
                Lista Veículos
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-2">
                <InputForm
                    type="text"
                    label="Filtrar por qualquer campo"
                    placeholder="Filtrar por qualquer campo..."
                    value={filtro}
                    onChange={e => setFiltro(e.target.value)}
                />

                <div className="flex items-end">
                    <Button
                        onClick={() => exportarParaExcel(veiculosFiltrados)}
                        label="Exportar para Excel"
                        variant="green"
                        textColor="white"
                        iconLeft="fa fa-file-excel"
                    />
                </div>
                <div></div>
                <div className="flex justify-end items-end font-bold">
                    Total de Registros:   {veiculosFiltrados.length}
                </div>
            </div>

            <div className="overflow-auto max-h-[300px]" >
                <table className="min-w-full text-sm whitespace-nowrap">
                    <thead className="bg-table-header text-table-header-fg sticky top-0">
                        <tr>
                            <Th>Código</Th>
                            <Th>Placa</Th>
                            <Th>Modelo</Th>
                            <Th>Fabricante</Th>
                            <Th>Tipo</Th>
                            <Th>Centro de Custo</Th>
                            <Th>Filial</Th>
                            <Th>Ano Fab.</Th>
                            <Th>Ano Mod.</Th>
                            <Th>KM Rodado</Th>
                            <Th>Chassis</Th>
                            <Th>Renavam</Th>
                            <Th>Estado</Th>
                        </tr>
                    </thead>

                    <tbody>
                        {veiculosFiltrados.length === 0 && (
                            <tr>
                                <td colSpan={12} className="text-center py-6 text-muted-foreground">
                                    Nenhum veículo encontrado
                                </td>
                            </tr>
                        )}

                        {veiculosFiltrados.map((v, i) => (
                            <tr key={i} className="border-b border-table-border hover:bg-table-row-hover transition-colors">
                                <Td>{v.codigo}</Td>
                                <Td>{v.placa}</Td>
                                <Td>{v.modelo}</Td>
                                <Td>{v.fabricante}</Td>
                                <Td>{v.tipo}</Td>
                                <Td>{v.centroCusto}</Td>
                                <Td>{v.filial}</Td>
                                <Td>{v.anoFabricacao}</Td>
                                <Td>{v.anoModelo}</Td>
                                <Td align="right">
                                    {v.kmRodado?.toLocaleString("pt-BR")}
                                </Td>
                                <Td>{v.chassis}</Td>
                                <Td>{v.renavam}</Td>
                                <Td>{v.estado}</Td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function Th({ children }) {
    return (
        <th className="px-6 py-2  text-xs font-medium text-table-header-fg uppercase sticky top-0 left-0 bg-table-header z-30">
            {children}
        </th>
    );
}

function Td({ children, align = "left" }) {
    return (
        <td
            className={`px-3 py-2 text-${align}`}
        >
            {children || "-"}
        </td>
    );
}

function exportarParaExcel(veiculos) {
    if (!veiculos || veiculos.length === 0) return;

    const dados = veiculos.map(v => ({
        Código: v.codigo,
        Placa: v.placa,
        Modelo: v.modelo,
        Fabricante: v.fabricante,
        Tipo: v.tipo,
        "Centro de Custo": v.centroCusto,
        Filial: v.filial,
        "Ano Fabricação": v.anoFabricacao,
        "Ano Modelo": v.anoModelo,
        "KM Rodado": v.kmRodado,
        Chassis: v.chassis,
        Renavam: v.renavam,
        Estado: v.estado,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dados);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Veículos");

    XLSX.writeFile(workbook, "veiculos_km_alto.xlsx");
}